import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/sysFields/load',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/sysFields/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function addField(code) {
  return request({
    url: '/sysFields/AddField',
    method: 'get',
    params: { code: code }
  });
}

export function changeOtherField(code) {
  return request({
    url: '/sysFields/ChangeOtherField',
    method: 'get',
    params: { code: code }
  });
}

export function add(data) {
  return request({
    url: '/sysFields/add',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/sysFields/update',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/sysFields/delete',
    method: 'post',
    data
  });
}

export function queryField(code) {
  return request({
    url: '/sysFields/queryField',
    method: 'get',
    params: { code: code }
  });
}

export function queryFilter(code) {
  return request({
    url: '/sysFields/queryFilter',
    method: 'get',
    params: { code: code }
  });
}

export function loadSetLeft(code) {
  return request({
    url: '/sysFields/queryFieldLeft',
    method: 'get',
    params: { code: code }
  });
}

export function loadSetRight(code) {
  return request({
    url: '/sysFields/queryFieldRight',
    method: 'get',
    params: { code: code }
  });
}

export function addUserField(data) {
  return request({
    url: '/sysFields/addUserField',
    method: 'post',
    data
  });
}

